import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import CardIntegrantes from './CardIntegrantes';
import { membros } from './DetalhesCardIntegrantes';
import ListaParceiros from './ListaParceiros';
import backgroundImage from '../../assets/ImgFundo/FundoFaleConosco.jpg'; // Importe a imagem diretamente

export default function ListaIntegrantes() {
  return (
    <Box
      sx={{
        py: 8,
        backgroundColor: '#f0f0f0',
        backgroundImage: `  url(${backgroundImage})`,  
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        color: 'white',
      }}
    >
      <Container>
    
            <Typography
             variant="h2"
             align="center"
             gutterBottom
             style={{
               fontFamily: "'Lato', serif",
               color: "#800020",
               textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',

               paddingBottom: "10px",
               textTransform: "uppercase",
               animation: "glow 2s infinite alternate",
               marginTop: "7%"  // Aqui é onde você define o espaço superior
             }}
           >
          Conheça Nosso Grupo 
        </Typography>
        <Typography
          variant="h3"
          fontWeight="medium"
          textAlign="center"
          gutterBottom
          sx={{
            fontFamily: "'Merriweather', serif",
            color: '#d4af37', 
            
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',

            borderBottom: "4px solid #d4af37",
            mb: 4,
          }}
        >
          Pesquisadores e Membros da Equipe
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {Array.isArray(membros) && membros.length > 0 ? (
            membros.map((membro, index) => (
              <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
                <CardIntegrantes
                  {...membro}
                  sx={{
                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'scale(1.05)', // Efeito de zoom suave
                      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)', // Sombra mais pronunciada
                    },
                  }}
                />
              </Grid>
            ))
          ) : (
            <Typography variant="body1" textAlign="center" color="textSecondary">
              Nenhum membro encontrado.
            </Typography>
          )}
        </Grid>

        {/* Seção de Parceiros */}
        <Box sx={{ mt: 8 }}>
          <ListaParceiros />
        </Box>
      </Container>
    </Box>
  );
}